import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Text, HStack, Link as ChakraLink } from '@chakra-ui/react';
import appVersion from '../appVersion.json';
import Terms from './Terms';

const VisitorFooter = () => {
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [smsOpen, setSmsOpen] = useState(false);

  return (
    <Box
      as="footer"
      w="full"
      py={4}
      textAlign="center"
      color="whiteAlpha.700"
      fontSize="sm"
      mt="auto"
      bg="rgba(0,46,11,0.98)"
      position="relative"
    >
      <HStack justify="center" spacing={6} mb={2}>
        <ChakraLink
          as="button"
          color="white"
          fontSize="0.8em"
          display="block"
          textAlign="center"
          style={{ transition: 'color 0.2s, text-decoration 0.2s', background: 'none', border: 'none', boxShadow: 'none' }}
          _focus={{ outline: 'none', boxShadow: 'none', background: 'none', border: 'none' }}
          _hover={{ background: 'none', border: 'none', boxShadow: 'none' }}
          onClick={() => setTermsOpen(true)}
          onMouseOver={e => {
            e.currentTarget.style.color = '#22a000';
            e.currentTarget.style.textDecoration = 'underline';
          }}
          onMouseOut={e => {
            e.currentTarget.style.color = 'white';
            e.currentTarget.style.textDecoration = 'none';
          }}
        >
          Terms & Conditions
        </ChakraLink>
        <ChakraLink
          as="button"
          color="white"
          fontSize="0.8em"
          display="block"
          textAlign="center"
          style={{ transition: 'color 0.2s, text-decoration 0.2s', background: 'none', border: 'none', boxShadow: 'none' }}
          _focus={{ outline: 'none', boxShadow: 'none', background: 'none', border: 'none' }}
          _hover={{ background: 'none', border: 'none', boxShadow: 'none' }}
          onClick={() => setPrivacyOpen(true)}
          onMouseOver={e => {
            e.currentTarget.style.color = '#22a000';
            e.currentTarget.style.textDecoration = 'underline';
          }}
          onMouseOut={e => {
            e.currentTarget.style.color = 'white';
            e.currentTarget.style.textDecoration = 'none';
          }}
        >
          Privacy Policy
        </ChakraLink>
        <ChakraLink
           as={Link}
           to="/SMS-policy"
           color="white"
           fontSize="0.8em"
           display="block"
           textAlign="center"
           style={{ transition: 'color 0.2s, text-decoration 0.2s' }}
           _hover={{ color: '#22a000', textDecoration: 'underline' }} 
        >
          SMS Policy
        </ChakraLink>
      </HStack>
      <Text>
        &copy; Copyright {new Date().getFullYear()} Mobile Global Esports Inc.
      </Text>
      <Box position="absolute" right={4} bottom={2} color="whiteAlpha.700" fontSize="sm">
        Version: {appVersion.pre_version} {appVersion.version}
      </Box>
      {termsOpen && (
        <Terms
          documentPath="terms-and-conditions.html"
          title="Terms & Conditions"
          isOpen={termsOpen}
          onClose={() => setTermsOpen(false)}
          displayMode="popup"
        />
      )}
      {privacyOpen && (
        <Terms
          documentPath="privacy-policy.html"
          title="Privacy Policy"
          isOpen={privacyOpen}
          onClose={() => setPrivacyOpen(false)}
          displayMode="popup"
        />
      )}
      {smsOpen && (
        <Terms
          documentPath="sms-policy.html"
          title="SMS Policy"
          isOpen={smsOpen}
          onClose={() => setSmsOpen(false)}
          displayMode="popup"
        />
      )}
    </Box>
  );
};

export default VisitorFooter; 